import React from "react";
import { usePostHog } from "posthog-js/react";
import { useAuth } from "../../contexts/AuthContext";

const NoResultsFound = ({ onClearFilters, showTips }) => {
  const posthog = usePostHog();
  const {isLoggedIn} = useAuth();

  return (    <div className="flex flex-col h-full items-center justify-center text-white">
      <h2 className="text-2xl font-semibold mb-2">No results found</h2>
      <div className="mb-4 text-sm font-extralight">
        <p className="mb-2">Here are some tips while searching:</p>
        <ul>
          <li>Search for themes, moods, genres or instruments</li>
          <li>Use fewer or different keywords</li>
          <li>Double check for typos</li>
        </ul>
      </div>
      <button
        onClick={() => {
          posthog.capture(
            ` Click-ClearSearch-DiscoverMainPage`, {
              is_user_logged_in: isLoggedIn ? true : false,
            }
          );
          onClearFilters();
        }}
        className="flex items-center justify-center px-3 py-2 bg-white hover:bg-white/90 font-normal text-[#100f10] text-sm rounded-full"
      >
        Clear Search
      </button>
    </div>
  );
};

export default NoResultsFound;
